<div class="flex flex-col w-full gap-4 p-4">
  <div class="flex flex-row justify-between w-full">
    <div>
      <h5 *ngIf="!isSingleProxyChangeVote" class="mb-0" id="h5-srs-proxy-vote">Place Vote</h5>
      <h5 *ngIf="isSingleProxyChangeVote" class="mb-0" id="h5-srs-proxy-vote">
        Change Vote - Any supporting information from the previous vote will be lost once you cast the new vote.  If required, please attach a supporting information document in the field below.
      </h5>
      <p>
        <span class="body-large-regular text-subtle">Committee Members: </span>
        <span class="body-large-bold">{{ committeeMembersDescription }}</span>
      </p>
      <p *ngIf="isSingleProxyVote && committeeMembers[0].submitted">
        <span class="body-large-regular text-subtle"> Vote placed: </span>
        <span class="body-large-bold">{{
          committeeMembers[0].submitted | date : "dd/MM/yyyy"
        }}</span>
      </p>
    </div>
    <button id="srs-proxy-vote-close-icon" (click)="close()">
      <span class="text-lg material-symbols-rounded text-subtle">close</span>
    </button>
  </div>

  <mat-divider class="mb-4 border-gray-300"></mat-divider>
  <form [formGroup]="srsProxyVoteForm" class="flex flex-col w-full">
    <div class="flex flex-col w-full gap-4 lg:flex-row lg:children:w-1/3">
      <app-vote-option-card
        id="reconfirm-vote-option"
        [voteOptionId] = "srsVoteId.SVT_RECONFIRM"
        [voteOptions] = "srsVoteOptions"
        formControlName="reconfirmVoteOptionCtrl"
      ></app-vote-option-card>

      <app-vote-option-card
      id="revise-vote-option"
      [voteOptionId] = "srsVoteId.SVT_REVISE"
      [voteOptions] = "srsVoteOptions"
      formControlName="reviseVoteOptionCtrl"
      >
        <app-radio-group
        *ngIf="isSingleProxyVote"
        id="radio-lead-project-proposal"
        formControlName="leadProjectProposalCtrl"
        name="radio-lead-project-proposal"
        label="Would you be willing to lead the project proposal development?"
        [options]="leadProjectProposalOptions"
        >
        </app-radio-group>
      </app-vote-option-card>

      <app-vote-option-card
      id="withdraw-vote-option"
      [voteOptionId] = "srsVoteId.SVT_WITHDRAW"
      [voteOptions] = "srsVoteOptions"
      formControlName="withdrawVoteOptionCtrl"
      ></app-vote-option-card>

    </div>
    <div id="add-authorisation-doc" class="flex flex-col flex-grow pt-4">
      <files-upload
        title="Attach an authorisation document"
        accept=".pdf,.zip,.doc,.docx,.png,.rtf,.tif,.txt,.msg"
        formControlName="authorisationDocumentCtrl"
        [progress]="authDocUploadProgress"
      ></files-upload>
    </div>

    <div *ngIf="isSingleProxyVote" id="add-supporting-information" class="flex flex-col flex-grow">
      <files-upload
        title="Attach supporting information"
        accept=".pdf,.zip,.doc,.docx,.png,.rtf,.tif,.txt,.msg"
        formControlName="supportingInformationCtrl"
        [progress]="authDocUploadProgress"
      ></files-upload>
    </div>
  </form>

  <mat-divider class="border-gray-300"></mat-divider>

  <div class="flex flex-row justify-end gap-6">
    <button
      class="btn btn-neutral"
      (click)="close()"
      id="btn-srs-proxy-vote-cancel"
    >
      Cancel
    </button>
    <button
      class="btn btn-primary"
      id="btn-srs-proxy-vote-submit"
      (click)="submit()"
      [disabled]="srsProxyVoteForm.invalid"
    >
      Submit
    </button>
  </div>
</div>
